<template>
  <div>
    <div class="d-flex align-center justify-center py-8 bg-default">
      <v-container>
        <div class="text-center">
          <h4 class="secondary-font">Redefinir senha</h4>
          <h5 class="secondary-font text--secondary mt-2">
            Atualize a senha da sua conta
          </h5>
        </div>
      </v-container>
    </div>
    <RedefinirSenhaForm />
  </div>
</template>

<script>
import RedefinirSenhaForm from '@/views/RedefinirSenha/RedefinirSenhaForm'

export default {
  name: 'RedefinirSenha',
  components: {
    RedefinirSenhaForm
  }
}
</script>

<style></style>
